import { useState } from "react";
import {
  Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
  Radio, RadioGroup, Stack, Textarea,
} from "@/components/ui";
import type { AccionObservacion } from "../services/revision-documental.api";

interface Props {
  abierto: boolean;
  nombreDocumento: string;
  enviando: boolean;
  onCerrar: () => void;
  onConfirmar: (accion: AccionObservacion, comentario: string) => void;
}

/**
 * Observar un documento (spec §10): el revisor indica qué corregir y si la observación
 * DEVUELVE la solicitud a corrección (al terminar la revisión) o la BLOQUEA (se queda en
 * revisión hasta que el solicitante reemplace el documento).
 */
export function ObservarDocumentoDialog({ abierto, nombreDocumento, enviando, onCerrar, onConfirmar }: Props) {
  const [accion, setAccion] = useState<AccionObservacion>("DevolverACorreccion");
  const [comentario, setComentario] = useState("");

  const cerrar = () => {
    setAccion("DevolverACorreccion");
    setComentario("");
    onCerrar();
  };
  const valido = comentario.trim().length > 0 && comentario.trim().length <= 1000;

  return (
    <Dialog open={abierto} onOpenChange={(o) => (!o ? cerrar() : undefined)}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Observar documento</DialogTitle>
          <DialogDescription>{nombreDocumento}</DialogDescription>
        </DialogHeader>
        <Stack gap="md">
          <RadioGroup value={accion} onValueChange={(v) => setAccion(v as AccionObservacion)}>
            <Radio
              value="DevolverACorreccion"
              label="Devolver a corrección"
              description="Al terminar la revisión la solicitud regresa al solicitante para que reemplace el documento y la reenvíe."
            />
            <Radio
              value="Bloquear"
              label="Bloquear"
              description="La solicitud se queda en revisión: el solicitante reemplaza el documento sin reenviar y se vuelve a revisar."
            />
          </RadioGroup>
          <Textarea
            label="Observación"
            required
            rows={4}
            maxLength={1000}
            placeholder="Indica qué hay que corregir…"
            value={comentario}
            onChange={(e) => setComentario(e.currentTarget.value)}
          />
        </Stack>
        <DialogFooter>
          <Button variant="default" onClick={cerrar}>
            Cancelar
          </Button>
          <Button disabled={!valido} loading={enviando} onClick={() => onConfirmar(accion, comentario.trim())}>
            Observar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
